import { IFund, IMerchant } from './EditCustomerProfile';
import { IWeatherStation } from '../WeatherStation/WeatherStation'

export interface IAccount {
    customerId: number;
    contractId: number;
    accountStatusId: number;
    paymentTypeId: number;
    addressId: number;
    territoryId: number;
    systemId: number;
    abpAccountNumber: number;
    autoPay: boolean;
    paperInvoice: boolean;
    utilityAccountNumber: string;
    utilityName: string;
    createBy: string;
    fund: IFund;
    merchant: IMerchant;
    weatherStation: IWeatherStation;
    preventDesignatedHoldbackInvoice: boolean;
    prepaid: boolean;
}

export class Account implements IAccount {
    customerId: number;
    contractId: number;
    accountStatusId: number;
    paymentTypeId: number;
    addressId: number;
    territoryId: number;
    systemId: number;
    abpAccountNumber: number;
    autoPay: boolean;
    paperInvoice: boolean;
    utilityAccountNumber: string;
    utilityName: string;
    createBy: string;
    fund: IFund;
    merchant: IMerchant;
    taxable: boolean;
    taxExemptPercent: number;
    weatherStation: IWeatherStation;
    preventDesignatedHoldbackInvoice: boolean;
    prepaid: boolean;
}